export const START_UPLOAD_ATTACHMENT = 'START_UPLOAD_ATTACHMENT';
export const ATTACHMENT_PROGRESS = 'ATTACHMENT_PROGRESS';
export const ATTACHMENT_COMPLETE = 'ATTACHMENT_COMPLETE';
export const ATTACHMENT_LOCAL_COMPLETE = 'ATTACHMENT_LOCAL_COMPLETE';
export const ATTACHMENT_DELETED = 'ATTACHMENT_DELETED';
export const ATTACHMENT_RENAMED = 'ATTACHMENT_RENAMED';